module.exports = __webpack_public_path__ + "media/auto_data/data-picker-0035bfff.png";